export const formatDate = (date: Date, format: string): string => {
  const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "2-digit", day: "2-digit" };
  return new Intl.DateTimeFormat("it-IT", options).format(date);
};

export const calculatePercentage = (part: number, total: number): number => {
  if (total === 0) return 0;
  return (part / total) * 100;
};

export const sortData = <T>(data: T[], key: keyof T, ascending: boolean = true): T[] => {
  return data.sort((a, b) => {
    if (a[key] < b[key]) return ascending ? -1 : 1;
    if (a[key] > b[key]) return ascending ? 1 : -1;
    return 0;
  });
};

export function ExtractEnumStates<T extends { [key: string]: string | number }>(
  enumObj: T
): string[] {
  return Object.keys(enumObj)
    .filter((key) => isNaN(Number(key))) // ignore reverse numeric keys
    .map((key) => enumObj[key].toString());
}
